<template>
  <a-select
    @change="(e)=>findEvent({e})"
    @blur="(e)=>findEvent({e,eventName:'blur'})"
    @focus="(e)=>findEvent({e,eventName:'focus'})"
    @select="(e)=>findEvent({e,eventName:'select'})"
    v-bind="$attrs.item"
    v-model="modelList[name]"
  >
    <a-select-option
      v-for="item in $attrs.item.selectOptions"
      :key="item.value"
      :disabled="item.disabled"
    >
      {{ item.label }}
    </a-select-option>
  </a-select>
</template>

<script>
import formMixin from "@/minxin/form.mixin.js";
import { Select } from "ant-design-vue";
import Vue from 'vue'
Vue.use(Select)
export default {
  mixins: [formMixin],
  props: {
    modelList: {},
    funcList: {},
    name: {},
  },
};
</script>
